import React, { useEffect, useState } from "react";
import "../styles/contact.css";
import { WHATSAPP_NUMBER, API_BASE } from "../config";
import trackPageView from "../utils/trackPageView";

function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);

  useEffect(() => {
    trackPageView("contact");
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const res = await fetch(`${API_BASE}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Failed to send");
      setStatus("sent");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setStatus("error");
    }
  };

  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi, I'd like to get in touch."
  )}`;

  return (
    <main className="contact-page">
      <section className="page-header">
        <h1>Contact Us</h1>
        <p>Have a question or want a quote? Reach out below.</p>
      </section>

      <section className="contact-content">
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            Name
            <input type="text" name="name" value={form.name} onChange={handleChange} required />
          </label>
          <label>
            Email
            <input type="email" name="email" value={form.email} onChange={handleChange} required />
          </label>
          <label>
            Message
            <textarea name="message" rows="5" value={form.message} onChange={handleChange} required />
          </label>
          <button type="submit" className="btn-primary" disabled={status === "sending"}>
            {status === "sending" ? "Sending..." : "Send Message"}
          </button>
          {status === "sent" && <p className="form-status success">Message sent, we'll get back to you soon.</p>}
          {status === "error" && <p className="form-status error">Something went wrong, please try again.</p>}
        </form>

        <div className="contact-info">
          <h3>Reach us directly</h3>
          <p>Email: info@krivaexim.com</p>
          <p>Phone: <a href="tel:+918830149701">+91 8830149701</a></p>
          <a href={waLink} target="_blank" rel="noopener noreferrer" className="btn-secondary">
            Chat on WhatsApp
          </a>
        </div>
      </section>
    </main>
  );
}

export default Contact;
